import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pi pi-info-circle p-2"
}



import type { ValueItem, ProductItem } from '../utils/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ItemLabel',
  props: {
    item: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(_ctx.item.name) + " ", 1),
    (_ctx.item.tip)
      ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_1, null, 512)), [
          [_directive_tooltip, {
      value: _ctx.item.tip,
      pt: {
        root: {
          style: {
            width: '700px',
            'max-width': '60%',
            'font-size': '14px',
          },
        },
      },
    }]
        ])
      : _createCommentVNode("", true)
  ], 64))
}
}

})